import * as React from 'react'
import { connect } from 'react-redux'
import ds from '../Services/DataServices'
import IntlMessages from '../util/IntlMessages'
import { message } from 'antd'
import { isEmptyObject } from '../appRedux/actions'
import Spinner from 'reactstrap/lib/Spinner'
// import { REACT_APP_BUS_SITE_APP } from '../constants/StoreSetting';
import { env } from '../env'

const { REACT_APP_BUS_SITE_APP } = env

const UserVerifyyy = props => {
  const token =
    props.match.params && props.match.params.token
      ? props.match.params.token
      : ''
  const [getResult, setResult] = React.useState({})
  const [getEnvReqCount, setEnvReqCount] = React.useState(0)
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      ensureDataFetched()
    }
    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted && !isEmptyObject(getResult)) {
      if (getResult == null || getResult.msgCode == '') {
        message.warn(
          "Verification in progress, we'll notify after setting up store",
          4
        )
        setTimeout(() => {
          window.location.href = `${REACT_APP_BUS_SITE_APP}/SignUp`
        }, 3000)
      } else if (getResult.msgCode === 'EMAIL_TOKEN_MISSING') {
        message.error(getResult.msgDescription)
        setTimeout(() => {
          window.location.href = `${REACT_APP_BUS_SITE_APP}/SignUp`
        }, 3000)
      } else if (getResult.msgCode === '1') {
        message.success('Store has been setup successfully.')

        setTimeout(() => {
          window.location.href = `${REACT_APP_BUS_SITE_APP}/SignIn`
        }, 3000)
      } else if (getResult.msgCode === '0') {
        if (getEnvReqCount > 13) {
          if (getEnvReqCount == 0) {
            setEnvReqCount(getEnvReqCount + 1)
          }
          setTimeout(() => {
            envSatusService(token, true)
          }, 5000)
        } else {
          setTimeout(() => {
            notifyLater()
          }, 160000)
        }
      } else if (getResult.msgCode === '-1') {
        notifyLater()
      } else if (getResult.msgCode === 'EMAIL_ALREADY_VERIFIED') {
        message.success(getResult.msgDescription)
        setTimeout(() => {
          window.location.href = `${REACT_APP_BUS_SITE_APP}/SignIn`
        }, 3000)
      }
    }

    return () => (mounted = false)
  }, [getResult])

  function notifyLater () {
    message.success('We will notify you after setting up the store', 5)
    setTimeout(() => {
      window.location.href = `${REACT_APP_BUS_SITE_APP}/SignIn`
    }, 4000)
  }

  async function ensureDataFetched () {
    const tokenJson = {
      EmailGuid: token
    }
    let emailResult = {
      data: {
        data: '',
        msgCode: '',
        msgDescription: ''
      }
    }
    console.log('calling verification API start')
    const userVerification = ds.userVerification(tokenJson)
    await userVerification
      .then(response => (emailResult.data = response.data))
      .catch(e => {
        message.error('Please Try Again...')
        setTimeout(() => {
          window.location.href = `${REACT_APP_BUS_SITE_APP}/SignUp`
        }, 3000)
      })
    console.log('response is', emailResult.data)
    console.log('calling verification API end')
    if (emailResult.data.msgCode === 'EMAIL_TOKEN_MISSING') {
      message.error(emailResult.data.msgDescription)
      setTimeout(() => {
        window.location.href = `${REACT_APP_BUS_SITE_APP}/SignUp`
      }, 3000)
    }
    if (emailResult.data.msgCode === 'EMAIL_VERIFIED') {
      envSatusService(token)
      // message.success(emailResult.data.msgDescription);
      // setTimeout(() => { window.location.href = "/SignIn"; }, 10000);
    }
    if (emailResult.data.msgCode === 'EMAIL_ALREADY_VERIFIED') {
      message.success(emailResult.data.msgDescription)
      console.log(window.location.href)
      setTimeout(() => {
        window.location.href = `${REACT_APP_BUS_SITE_APP}/SignIn`
      }, 5000)
      // if(emailResult.data.data){
      //     setTimeout(() => { window.location.href = `${REACT_APP_BUS_SITE_APP.replace("app", emailResult.data.data)}`; }, 5000);
      // }
      // else {
      //     setTimeout(() => { window.location.href = `${REACT_APP_BUS_SITE_APP}/SignIn`; }, 5000);
      // }
    }
    if (emailResult.data == null || emailResult.data.msgCode == '') {
      message.error(
        "Verification in progress, we'll notify after setting up store",
        4
      )
      setTimeout(() => {
        window.location.href = `${REACT_APP_BUS_SITE_APP}/SignUp`
      }, 3000)
    }
  }

  async function envSatusService (token, increment) {
    if (increment) setEnvReqCount(getEnvReqCount + 1)
    const tokenJson = {
      EmailGuid: token
    }
    let result = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    const status = ds.getVerificationService(tokenJson)
    await status
      .then(response => {
        result.data = response.data
        setResult(result.data)
      })
      .catch(e => {
        message.error(
          'Connection broke, we will notify you on your email after setting up your store',
          5
        )
        // setTimeout(() => { window.location.href = "/SignUp"; }, 3000);
      })
  }

  return (
    <React.Fragment>
      <div
        className='confirm'
        style={{ textAlign: 'center', marginTop: '108px' }}
      >
        <h2>
          <IntlMessages id='userverify.settingup' />
        </h2>
        <p>
          <IntlMessages id='userverify.sitbackrelax' />
        </p>
        <Spinner style={{ width: '3rem', height: '3rem' }} color='primary' />
      </div>
    </React.Fragment>
  )
}

export default connect()(UserVerifyyy)
